import { render, staticRenderFns } from "./StaffPageCreateForm.vue?vue&type=template&id=ac1546fa&scoped=true&"
import script from "./StaffPageCreateForm.vue?vue&type=script&lang=js&"
export * from "./StaffPageCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1546fa",
  null
  
)

export default component.exports